import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ROVO_AWARENESS_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-rovo-awareness.ts';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadRovoAwarenessOnboardingState = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [...Object.values(ROVO_AWARENESS_ONBOARDING_STATE_KEYS)],
		},
	});
};
